export default __webpack_public_path__ + "static/media/Success.19e1b044.svg";